'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

// Utils


// Actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _staticResourceUtil = require('./staticResourceUtil');

var _createMarkup = require('../../utils/react/createMarkup');

var _createMarkup2 = _interopRequireDefault(_createMarkup);

var _staticResourceActions = require('./staticResourceActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
    var resourceName = (0, _staticResourceUtil.getStaticHtmlResourceName)(ownProps.htmlName);

    return {
        resource: state.get('app').get('staticResources').get(resourceName)
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        fetchResource: function fetchResource(resourceName) {
            return dispatch((0, _staticResourceActions.fetchStaticHtml)(resourceName));
        }
    };
};

var StaticHtml = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(StaticHtml, _React$Component);

    function StaticHtml() {
        _classCallCheck(this, StaticHtml);

        return _possibleConstructorReturn(this, (StaticHtml.__proto__ || Object.getPrototypeOf(StaticHtml)).apply(this, arguments));
    }

    _createClass(StaticHtml, [{
        key: 'componentWillMount',


        /**
         * When mounting, make sure the resource has been or will be fetched.
         */
        value: function componentWillMount() {
            var _props = this.props,
                fetchResource = _props.fetchResource,
                htmlName = _props.htmlName;

            fetchResource(htmlName);
        }
    }, {
        key: 'render',
        value: function render() {
            var resource = this.props.resource;


            var displayElement = _react2.default.createElement(
                'div',
                null,
                'Loading...'
            );
            if (resource && resource.get('fetched')) {
                var innerHtml = (0, _createMarkup2.default)(resource.get('data'));
                displayElement = _react2.default.createElement('div', { dangerouslySetInnerHTML: innerHtml });
            }

            return displayElement;
        }
    }]);

    return StaticHtml;
}(_react2.default.Component)) || _class);


StaticHtml.propTypes = {
    htmlName: _propTypes2.default.string.isRequired,
    fetchResource: _propTypes2.default.func,
    resource: _propTypes2.default.object
};

exports.default = StaticHtml;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/static/StaticHtml.js
// module id = 1931
// module chunks = 0